const verge = require('verge');
const platform = require('platform');
const throttle = require('throttle-debounce/throttle');
import modernizr from '../../.modernizrrc';

const $ourValues = $('.js-our-values');
const $ourValuesComplete = $('.js-our-values--complete');
const $iconFleetDevelopment = $('#fleet_development_icon');
const $iconOurStory = $('#our_story_icon');
const $iconOurTeam = $('#our_team_icon');
const $iconBSM = $('#bsm_icon');
const $iconTalentManagement = $('#talent_management_icon');
const $iconCompliance = $('#compliance_icon');
const $iconASD = $('#asd_icon');
const $iconMarketing = $('#marketing_icon');
const $iconFinance = $('#finance_icon');
const $iconVacancies = $('#vacancies_icon');
const $imgWhoWeAre = $('#who_we_are_img');
const platformName = platform.name;


if ($ourValues.length) {
	if (verge.viewportW() > 768) {
		$ourValues
			.find('.our-values__item')
			.velocity("transition.slideDownIn", {
				stagger: 350,
				complete: function () {
					$ourValuesComplete
						.velocity("transition.fadeIn");
				}
			});
	} else {
		$(window).on('resize', throttle(300, function (e) {
			if (verge.viewportW() > 768 && !$ourValues.find('.our-values__item').is(":visible")) {
				$ourValues
					.find('.our-values__item')
					.show();
				$ourValuesComplete
					.show();
			}
		}));
	}
}

$(function () {
	modernizr.addTest('svg-transforms', () => {
		const
			vendorPrefixesCss = ['-moz-', '-ms-', '-webkit-', ''],

			// reduce vendor prefix array to create a cssText string.
			styleRules = vendorPrefixesCss.reduce((prev, curr) => {
				return prev + curr + 'transform: translateX(10px); ';
			}, ''),

			body = document.querySelector('body'),
			svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
			path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

		// Append elements to dom
		svg.appendChild(path);
		svg.style.cssText = 'width: 100px; visibility: transparent;';
		body.appendChild(svg);

		// getBoundingClientRect to determine if transform applied successfully.
		const initialBoundingRect = path.getBoundingClientRect();
		path.style.cssText = styleRules;
		const newBoundingRect = path.getBoundingClientRect();

		body.removeChild(svg);

		return (initialBoundingRect.left != newBoundingRect.left);
	});
});

function showAnimationWhoWeAre() {
	if ($imgWhoWeAre.length) {
		$imgWhoWeAre
			.addClass('is-animated');

		$imgWhoWeAre
			.find('#circle-1-1')
			.velocity({
				fillOpacity: 1
			}, {
				duration: 300,
				delay: 400
			});
		$imgWhoWeAre
			.find('#line-1-2_1-mask, #line-1-2_2-mask')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1200,
				delay: 700
			});

		if (platformName !== 'IE' && platformName !== 'Firefox' && platformName !== 'Microsoft Edge') {
			$imgWhoWeAre
				.find('#air-1 path, #air-2 path')
				.velocity({
					fillOpacity: 1
				}, {
					duration: 600,
					delay: 700
				});

			$imgWhoWeAre
				.find('#air-1')
				.velocity({
					translateX: [50, 0],
					translateY: [-3, 0],
					rotateZ: ["6deg", 0]
				}, {
					duration: 100,
					delay: 800,
					easing: 'linear'
				})
				.velocity({
					translateX: [100, 50],
					rotateZ: ["11deg", "6deg"]
				}, {
					duration: 100,
					easing: 'linear'
				})
				.velocity({
					translateX: [150, 100],
					translateY: [11, -3],
					rotateZ: ["19deg", "11deg"]
				}, {
					duration: 100,
					easing: 'linear'
				})
				.velocity({
					translateX: [200, 150],
					translateY: [43, 11],
					rotateZ: ["31deg", "19deg"]
				}, {
					duration: 100,
					easing: 'linear'
				})
				.velocity({
					translateX: [245, 200],
					translateY: [96, 43],
					rotateZ: ["46deg", "31deg"]
				}, {
					duration: 100,
					easing: 'linear'
				});

			$imgWhoWeAre
				.find('#air-2')
				.velocity({
					translateX: [50, 0],
					translateY: [7, 0],
					rotateZ: ["0.6deg", 0]
				}, {
					duration: 90,
					delay: 800,
					easing: 'linear'
				})
				.velocity({
					translateX: [100, 50],
					translateY: [25, 7],
					rotateZ: ["5deg", "0.6deg"]
				}, {
					duration: 90,
					easing: 'linear'
				})
				.velocity({
					translateX: [150, 100],
					translateY: [48, 25],
					rotateZ: ["9deg", "5deg"]
				}, {
					duration: 90,
					easing: 'linear'
				})
				.velocity({
					translateX: [200, 150],
					translateY: [84, 48],
					rotateZ: ["17deg", "9deg"]
				}, {
					duration: 90,
					easing: 'linear'
				})
				.velocity({
					translateX: [250, 200],
					translateY: [140, 84],
					rotateZ: ["28deg", "17deg"]
				}, {
					duration: 90,
					easing: 'linear'
				})
				.velocity({
					translateX: [275, 250],
					translateY: [181, 140],
					rotateZ: ["35deg", "28deg"]
				}, {
					duration: 70,
					easing: 'linear'
				});

			$imgWhoWeAre
				.find('#air-1 path, #air-2 path')
				.velocity({
					fillOpacity: 0
				}, {
					duration: 600,
					delay: 100
				});


// =======================================================> Air1
			$imgWhoWeAre
				.find('#air-1')
				.velocity({
					translateX: [109, 0],
					translateY: [-94, 0],
					rotateZ: ["-85deg", 0]
				}, {
					delay: 600,
					duration: 0,
					easing: 'linear'
				});


			$imgWhoWeAre
				.find('#air-1 path')
				.velocity({
					fillOpacity: 1
				}, {
					duration: 600,
					delay: 10
				});

			$imgWhoWeAre
				.find('#air-1')
				.velocity({
					translateX: [117, 109],
					translateY: [-131, -94],
					rotateZ: ["-78deg", "-85deg"]
				}, {
					duration: 100,
					delay: 10,
					easing: 'linear'
				})
				.velocity({
					translateX: [127, 117],
					translateY: [-152, -131],
					rotateZ: ["-73deg", "-78deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [151, 127],
					translateY: [-177, -152],
					rotateZ: ["-63deg", "-73deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [204, 151],
					translateY: [-191, -177],
					rotateZ: ["-43deg", "-63deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [267, 204],
					translateY: [-168, -191],
					rotateZ: ["-16deg", "-43deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [293, 267],
					translateY: [-141, -168],
					rotateZ: ["-1deg", "-16deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [325, 293],
					translateY: [-105, -141],
					rotateZ: ["17deg", "-1deg"]
				}, {
					duration: 50,
					easing: 'linear'
				});

// <======================================================= Air1

// =======================================================> Air2
			$imgWhoWeAre
				.find('#air-2')
				.velocity({
					translateX: [70, 0],
					translateY: [50, 0],
					rotateZ: ["256deg", 0]
				}, {
					delay: 600,
					easing: 'linear'
				});

			$imgWhoWeAre
				.find('#air-2 path')
				.velocity({
					fillOpacity: 1
				}, {
					duration: 600,
					delay: 600
				});

			$imgWhoWeAre
				.find('#air-2')
				.velocity({
					translateX: [53, 70],
					translateY: [20, 50],
					rotateZ: ["250deg", "256deg"]
				}, {
					duration: 50,
					delay: 550,
					easing: 'linear'
				})
				.velocity({
					translateX: [34, 53],
					translateY: [-10, 20],
					rotateZ: ["245deg", "250deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [18, 34],
					translateY: [-40, -10],
					rotateZ: ["243deg", "245deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [-1, 18],
					translateY: [-70, -40],
					rotateZ: ["240deg", "243deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [-30, -1],
					translateY: [-100, -70],
					rotateZ: ["234deg", "240deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [-77, -30],
					translateY: [-120, -100],
					rotateZ: ["222deg", "234deg"]
				}, {
					duration: 40,
					easing: 'linear'
				})
				.velocity({
					translateX: [-99, -77],
					translateY: [-130, -120],
					rotateZ: ["218deg", "222deg"]
				}, {
					duration: 40,
					easing: 'linear'
				})
				.velocity({
					translateX: [-141, -99],
					translateY: [-124, -130],
					rotateZ: ["204deg", "218deg"]
				}, {
					duration: 40,
					easing: 'linear'
				})
				.velocity({
					translateX: [-177, -141],
					translateY: [-107, -124],
					rotateZ: ["190deg", "204deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [-210, -177],
					translateY: [-76, -107],
					rotateZ: ["173deg", "190deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [-225, -210],
					translateY: [-62, -76],
					rotateZ: ["167deg", "173deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [-260, -225],
					translateY: [-28, -62],
					rotateZ: ["155deg", "167deg"]
				}, {
					duration: 50,
					easing: 'linear'
				})
				.velocity({
					translateX: [-270, -260],
					translateY: [6, -28],
					rotateZ: ["142deg", "155deg"]
				}, {
					duration: 50,
					easing: 'linear'
				});

			$imgWhoWeAre
				.find('#air-2 path')
				.velocity({
					fillOpacity: 0
				}, {
					duration: 600,
					delay: 600
				});
// <======================================================= Air2
		} else {
			if (verge.viewportW() < 1260) {
				$imgWhoWeAre
					.find('#air-1-ie path, #air-2-ie path')
					.velocity({
						fillOpacity: 1
					}, {
						duration: 600,
						delay: 700
					});
			} else {
				$imgWhoWeAre
					.siblings('#air-1-png, #air-2-png')
					.velocity('transition.fadeIn', {
						duration: 600,
						delay: 200
					});

				$imgWhoWeAre
					.siblings('#air-1-png')
					.velocity({
						translateX: [50, 0],
						translateY: [-18, 0],
						rotateZ: ["5deg", 0]
					}, {
						duration: 30,
						easing: 'linear'
					})
					.velocity({
						translateX: [100, 50],
						translateY: [-31, -18],
						rotateZ: ["10.7deg", "5deg"]
					}, {
						duration: 60,
						easing: 'linear'
					})
					.velocity({
						translateX: [150, 100],
						translateY: [-37, -31],
						rotateZ: ["19deg", "10.7deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [200, 150],
						rotateZ: ["29deg", "19deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [245, 200],
						translateY: [-27, -37],
						rotateZ: ["41deg", "29deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [280, 245],
						translateY: [-13, -27],
						rotateZ: ["48deg", "41deg"]
					}, {
						duration: 90,
						easing: 'linear'
					});

				$imgWhoWeAre
					.siblings('#air-2-png')
					.velocity({
						translateX: [50, 0],
						translateY: [6, 0]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [100, 50],
						translateY: [14, 6],
						rotateZ: ["3deg", "0deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [150, 100],
						translateY: [26, 14],
						rotateZ: ["9deg", "3deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [200, 150],
						translateY: [43, 26],
						rotateZ: ["15deg", "9deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [250, 200],
						translateY: [67, 43],
						rotateZ: ["25deg", "15deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [295, 250],
						translateY: [104, 67],
						rotateZ: ["37deg", "25deg"]
					}, {
						duration: 70,
						easing: 'linear'
					});

				$imgWhoWeAre
					.siblings('#air-1-png, #air-2-png')
					.velocity('transition.fadeOut', {
						duration: 600,
						delay: 100
					});

// =======================================================> Air1 IE
				$imgWhoWeAre
					.siblings('#air-1-png')
					.velocity({
						translateX: [296, 0],
						translateY: [0, 0],
						rotateZ: ["-84deg", 0]
					}, {
						duration: 100,
						delay: 0,
						easing: 'linear'
					});

				$imgWhoWeAre
					.siblings('#air-1-png')
					.velocity('transition.fadeIn', {
						duration: 250,
						delay: 0,
						easing: 'linear'
					});

				$imgWhoWeAre
					.siblings('#air-1-png')
					.velocity({
						translateX: [286, 296],
						translateY: [-105, 0],
						rotateZ: ["-54deg", "-84deg"]
					}, {
						duration: 50,
						easing: 'linear'
					})
					.velocity({
						translateX: [295, 286],
						translateY: [-129, -105],
						rotateZ: ["-36deg", "-54deg"]
					}, {
						duration: 50,
						easing: 'linear'
					})
					.velocity({
						translateX: [309, 295],
						translateY: [-146, -129],
						rotateZ: ["-13deg", "-36deg"]
					}, {
						duration: 50,
						easing: 'linear'
					})
					.velocity({
						translateX: [345, 309],
						translateY: [-158, -146],
						rotateZ: ["18deg", "-13deg"]
					}, {
						duration: 50,
						easing: 'linear'
					});
// <======================================================= Air1 IE


// =======================================================> Air2 IE
				$imgWhoWeAre
					.siblings('#air-2-png')
					.velocity({
						translateX: [307, 0],
						translateY: [120, 0],
						rotateZ: ["-101deg", 0]
					}, {
						duration: 600,
						delay: 0,
						easing: 'linear'
					});

				$imgWhoWeAre
					.siblings('#air-2-png')
					.velocity('transition.fadeIn', {
						duration: 100,
						delay: 150
					});

				$imgWhoWeAre
					.siblings('#air-2-png')
					.velocity({
						translateX: [301, 307],
						translateY: [80, 120],
						rotateZ: ["-108deg", "-101deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [280, 301],
						translateY: [10, 80],
						rotateZ: ["-117deg", "-108deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [247, 280],
						translateY: [-66, 10],
						rotateZ: ["-125deg", "-117deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [207, 247],
						translateY: [-126, -66],
						rotateZ: ["-136deg", "-125deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [164, 207],
						translateY: [-168, -126],
						rotateZ: ["-150deg", "-136deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [113, 164],
						translateY: [-196, -168],
						rotateZ: ["-166deg", "-150deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [71, 113],
						translateY: [-207, -196],
						rotateZ: ["-181deg", "-166deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [40, 71],
						translateY: [-208, -207],
						rotateZ: ["-189deg", "-181deg"]
					}, {
						duration: 90,
						easing: 'linear'
					})
					.velocity({
						translateX: [9, 40],
						translateY: [-206, -208],
						rotateZ: ["-196deg", "-189deg"]
					}, {
						duration: 70,
						easing: 'linear'
					})
					.velocity({
						translateX: [-46, 9],
						translateY: [-190, -206],
						rotateZ: ["-209deg", "-196deg"]
					}, {
						duration: 70,
						easing: 'linear'
					})
					.velocity({
						translateX: [-69, -46],
						translateY: [-177, -190],
						rotateZ: ["-223deg", "-209deg"]
					}, {
						duration: 50,
						easing: 'linear'
					});

				$imgWhoWeAre
					.siblings('#air-2-png')
					.velocity('transition.fadeOut', {
						duration: 200
					});
// <======================================================= Air2 IE
			}
		}

		// $imgWhoWeAre
		// 	.find('#line-1-2_2_1-mask')
		// 	.velocity({
		// 		strokeDashoffset: 0
		// 	}, {
		// 		duration: 1000,
		// 		delay: 700
		// 	});
		$imgWhoWeAre
			.find('#circle-1-2_1, #circle-1-2_2')
			.velocity({
				fillOpacity: 1
			}, {
				duration: 300,
				delay: 1700
			});
		$imgWhoWeAre
			// .find('#line-1-2_2-3_1-mask, #line-1-2_2-3_2-mask')
			.find('#line-1-2_2-3_2-mask')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 600,
				delay: 2000
			});
		$imgWhoWeAre
			// .find('#circle-1-2_2-3_1, #circle-1-2_2-3_2')
			.find('#circle-1-2_2-3_2')
			.velocity({
				fillOpacity: 1
			}, {
				duration: 300,
				delay: 2600
			});
		$imgWhoWeAre
			.find('#line-1-2_1-3_3-mask')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 2900
			});
		$imgWhoWeAre
			.find('#circle-1-2_1-3_3')
			.velocity({
				fillOpacity: 1
			}, {
				duration: 300,
				delay: 3900
			});

		if (platformName !== 'IE' && platformName !== 'Firefox' && platformName !== 'Microsoft Edge') {
			$imgWhoWeAre
				.find('#air-3 path')
				.velocity({
					fillOpacity: 1
				}, {
					duration: 600,
					delay: 4100
				});

			$imgWhoWeAre
				.find('#air-3')
				.velocity({
					translateX: [100, 0],
					translateY: [23, 0],
					rotateZ: ["-5deg", 0]
				}, {
					duration: 180,
					delay: 4200,
					easing: 'linear'
				})
				.velocity({
					translateX: [200, 100],
					translateY: [33, 23],
					rotateZ: ["-10deg", "-5deg"]
				}, {
					duration: 180,
					easing: 'linear'
				})
				.velocity({
					translateX: [300, 200],
					translateY: [32, 33],
					rotateZ: ["-16deg", "-10deg"]
				}, {
					duration: 180,
					easing: 'linear'
				})
				.velocity({
					translateX: [400, 300],
					translateY: [38, 32],
					rotateZ: ["-18deg", "-16deg"]
				}, {
					duration: 180,
					easing: 'linear'
				})
				.velocity({
					translateX: [466, 400],
					translateY: [35, 38],
					rotateZ: ["-20.7deg", "-18deg"]
				}, {
					duration: 100,
					easing: 'linear'
				});

			// $imgWhoWeAre
			// 	.find('#air-3 path')
			// 	.velocity({
			// 		fillOpacity: 0
			// 	}, {
			// 		duration: 600,
			// 		delay: 200
			// 	});
		} else {
			if (verge.viewportW() < 1260) {
				$imgWhoWeAre
					.find('#air-3-ie path')
					.velocity({
						fillOpacity: 1
					}, {
						duration: 600,
						delay: 4100
					});
			} else {
				$imgWhoWeAre
					.siblings('#air-3-png')
					.velocity('transition.fadeIn', {
						duration: 600,
						delay: 3700
					});

				$imgWhoWeAre
					.siblings('#air-3-png')
					.velocity({
						translateX: [100, 0],
						translateY: [42, 0],
						rotateZ: ["-5deg", 0]
					}, {
						duration: 80,
						easing: 'linear'
					})
					.velocity({
						translateX: [200, 100],
						translateY: [72, 42],
						rotateZ: ["-10deg", "-5deg"]
					}, {
						duration: 180,
						easing: 'linear'
					})
					.velocity({
						translateX: [300, 200],
						translateY: [94, 72],
						rotateZ: ["-15deg", "-10deg"]
					}, {
						duration: 200,
						easing: 'linear'
					})
					.velocity({
						translateX: [400, 300],
						translateY: [108, 94],
						rotateZ: ["-19.4deg", "-15deg"]
					}, {
						duration: 200,
						easing: 'linear'
					})
					.velocity({
						translateX: [465, 400],
						translateY: [114, 108],
						rotateZ: ["-21deg", "-19.4deg"]
					}, {
						duration: 150,
						easing: 'linear'
					});

				// $imgWhoWeAre
				// 	.siblings('#air-3-png')
				// 	.velocity('transition.fadeOut', {
				// 		duration: 600
				// 	});
			}
		}

		$imgWhoWeAre
			.find('#line-1-2_1-3_3-4-mask')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 4200,
				easing: 'linear'
			});
		$imgWhoWeAre
			.find('#circle-1-2_1-3_3-4')
			.velocity({
				fillOpacity: 1
			}, {
				duration: 300,
				delay: 5200
			});
	}
}

$(document).on('touchmove scroll mousewheel DOMMouseScroll', function () {
	if (verge.inViewport($imgWhoWeAre, -300)) {
		if (!$imgWhoWeAre.hasClass('is-animated')) {
			showAnimationWhoWeAre();
		}
	}
});

$(function () {
	if (verge.inViewport($imgWhoWeAre, -300)) {
		showAnimationWhoWeAre();
	}
});

$(function () {
	// WORK ICONS
	if ($iconFleetDevelopment.length) {
		$iconFleetDevelopment
			.velocity({
				translateX: '-15%',
				translateY: '15%'
			}, {
				duration: 0
			});
		$iconFleetDevelopment
			.find('.js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1200,
				delay: 400,
				begin: function () {
					$iconFleetDevelopment
						.velocity({
							translateX: 0,
							translateY: 0
						}, {
							delay: 1000
						});
				}
			});
	}
	if ($iconOurStory.length) {
		$iconOurStory
			.find('#back .js-stroke-animation')
			.velocity({
				strokeDashoffset: 170
			}, {
				duration: 1000,
				delay: 400
			});
		$iconOurStory
			.find('#lines .js-stroke-animation')
			.velocity({
				strokeDashoffset: 235
			}, {
				duration: 600,
				delay: 1000
			});
		$iconOurStory
			.find('#anchor .js-stroke-animation')
			.velocity({
				strokeDashoffset: 170,
				fillOpacity: 1
			}, {
				duration: 500,
				delay: 1200
			});
	}
	if ($iconOurTeam.length) {
		$iconOurTeam
			.find('.js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 400
			});
		// $iconOurTeam
		// 	.find('#man .js-stroke-animation, #man_1 .js-stroke-animation')
		// 	.velocity({
		// 		strokeDashoffset: 0
		// 	}, {
		// 		duration: 1000,
		// 		delay: 400
		// 	});
		// $iconOurTeam
		// 	.find('#lines .js-stroke-animation')
		// 	.velocity({
		// 		strokeDashoffset: 170
		// 	}, {
		// 		duration: 600,
		// 		delay: 1000
		// 	});
	}
	if ($iconBSM.length) {
		$iconBSM
			.find('.js-circle')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 800,
				delay: 400
			});
		$iconBSM
			.find('#arrow-1 .js-stroke-animation, #arrow-2 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 600,
				delay: 800
			});
		$iconBSM
			.find('.js-x')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 800,
				delay: 1200
			});
	}
	if ($iconTalentManagement.length) {
		$iconTalentManagement
			.find('.js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 400
			});
	}
	if ($iconCompliance.length) {
		$iconCompliance
			.find('#back .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 400
			});
		$iconCompliance
			.find('#row-1 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1000
			});
		$iconCompliance
			.find('#row-2 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1300
			});
		$iconCompliance
			.find('#row-3 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1600
			});
	}
	if ($iconASD.length) {
		$iconASD
			.find('#step-1 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 400
			});
		$iconASD
			.find('#step-2')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1000
			});
		$iconASD
			.find('#step-3')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1300
			});
		$iconASD
			.find('#step-4')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1600
			});
	}
	if ($iconMarketing.length) {
		$iconMarketing
			.find('#step-1 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 400
			});
		$iconMarketing
			.find('#step-2')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 300,
				delay: 1000
			});
		$iconMarketing
			.find('#step-3')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 300,
				delay: 1100
			});
		$iconMarketing
			.find('#step-4')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 300,
				delay: 1200
			});
		$iconMarketing
			.velocity({
				scale: 1.1
			}, {
				duration: 400,
				delay: 1150
			});
	}
	if ($iconFinance.length) {
		$iconFinance
			.find('#step-1 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 400
			});
		$iconFinance
			.find('#step-2 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1200
			});
		$iconFinance
			.find('#step-3 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 1600
			});
		$iconFinance
			.find('#step-4 .js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 2000
			});
	}
	if ($iconVacancies.length) {
		$iconVacancies
			.find('.js-stroke-animation')
			.velocity({
				strokeDashoffset: 0
			}, {
				duration: 1000,
				delay: 400
			});
	}
});



// WEBPACK FOOTER //
// ./frontend/components/animation/animation.js